// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const signalBeacon = defineModel({
  id: "signal-beacon",
  batchId: "future",
  name: "Signal beacon",
  tags: ["building","signal","beacon","low-poly","age-of-mcp","future","military"],
  summary: "A hilltop signal beacon — lit to warn neighbours of danger.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.45,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.7, 0.14, 0.7), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.7, 0.14, 0.7), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 0.5565, 5), color: "#6f4a26", position: [0.17, 0.4025, 0], rotation: [0, 0, -0.3] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 0.5565, 5), color: "#6f4a26", position: [-0.085, 0.4025, 0.147224], rotation: [0.259808, 0, 0.15] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 0.5565, 5), color: "#6f4a26", position: [-0.085, 0.4025, -0.147224], rotation: [-0.259808, 0, 0.15] },
      { geometry: new THREE.TorusGeometry(0.06, 0.012, 4, 8), color: "#553820", position: [0, 0.623, 0], rotation: [1.570796, 0, 0] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.7, 0.14, 0.7), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 1.113, 5), color: "#6f4a26", position: [0.17, 0.665, 0], rotation: [0, 0, -0.3] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 1.113, 5), color: "#6f4a26", position: [-0.085, 0.665, 0.147224], rotation: [0.259808, 0, 0.15] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 1.113, 5), color: "#6f4a26", position: [-0.085, 0.665, -0.147224], rotation: [-0.259808, 0, 0.15] },
      { geometry: new THREE.TorusGeometry(0.06, 0.012, 4, 8), color: "#553820", position: [0, 1.106, 0], rotation: [1.570796, 0, 0] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.7, 0.14, 0.7), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 1.113, 5), color: "#6f4a26", position: [0.17, 0.665, 0], rotation: [0, 0, -0.3] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 1.113, 5), color: "#6f4a26", position: [-0.085, 0.665, 0.147224], rotation: [0.259808, 0, 0.15] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.045, 1.113, 5), color: "#6f4a26", position: [-0.085, 0.665, -0.147224], rotation: [-0.259808, 0, 0.15] },
      { geometry: new THREE.TorusGeometry(0.06, 0.012, 4, 8), color: "#553820", position: [0, 1.106, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.16, 0.1, 0.16, 8), color: "#3a3f44", position: [0, 1.146, 0] },
      { geometry: new THREE.TorusGeometry(0.15, 0.018, 4, 10), color: "#3a3f44", position: [0, 1.216, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.ConeGeometry(0.13, 0.28, 7), color: "#ff8a2a", position: [0, 1.366, 0] },
      { geometry: new THREE.ConeGeometry(0.08, 0.34, 6), color: "#ffd24a", position: [0.02, 1.426, 0.01] },
      { geometry: new THREE.ConeGeometry(0.05, 0.18, 5), color: "#c43a20", position: [-0.04, 1.306, 0.03] },
      { geometry: new THREE.BoxGeometry(0.02, 0.84, 0.02), color: "#8a5e34", position: [0.14, 0.581, 0.06], rotation: [0, 0, 0.12] },
      { geometry: new THREE.BoxGeometry(0.02, 0.84, 0.02), color: "#8a5e34", position: [0.22, 0.581, 0.06], rotation: [0, 0, 0.12] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.04, 0.3, 6), color: "#8a5e34", position: [-0.24, 0.19, 0.16], rotation: [1.570796, 0.4, 0] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.04, 0.3, 6), color: "#6f4a26", position: [-0.24, 0.19, 0.24], rotation: [1.570796, 0.7, 0] },
    ] },
  ],
  animations: [],
});
